module.exports = __webpack_public_path__ + "static/media/lobby-card-faq.f27bb22b.svg";